import PropTypes from 'prop-types'
import { InfoOutlined } from '@mui/icons-material'
import {
  Autocomplete,
  AutocompleteOption,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormLabel,
  ListItemContent,
} from '@mui/joy'

const CustomAutocompleteControl = ({
  name,
  label,
  formik,
  options,
  sx,
  labelProp = 'label',
  loading = false,
  placeholder = 'Wybierz',
  customRenderOption = null,
  ...rest
}) => {
  return (
    <FormControl error={formik.touched[name] && Boolean(formik.errors[name])} sx={sx}>
      <FormLabel sx={{ width: '100%' }}>{label}</FormLabel>
      <Autocomplete
        loading={loading}
        endDecorator={loading ? <CircularProgress size="sm" /> : null}
        options={options}
        loadingText="Wczytywanie danych..."
        noOptionsText="Brak wyników"
        placeholder={loading ? 'Wczytywanie danych...' : placeholder}
        getOptionLabel={(opt) => opt[labelProp]}
        getOptionKey={(opt) => opt.id}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={formik.values[name]}
        onChange={(e, value) => formik.setFieldValue(name, value)}
        onBlur={formik.handleBlur}
        renderOption={(props, option) => {
          // eslint-disable-next-line react/prop-types
          const { key, ...rest } = props
          return (
            <AutocompleteOption key={key} {...rest}>
              <ListItemContent>{customRenderOption ? customRenderOption(option) : option[labelProp]}</ListItemContent>
            </AutocompleteOption>
          )
        }}
        slotProps={{
          listbox: {
            disablePortal: true,
          },
          input: {
            autoComplete: 'new-password',
            id: name,
            name,
          },
        }}
        {...rest}
      />
      {formik.touched[name] && formik.errors[name] && (
        <FormHelperText sx={{ gap: 1 }}>
          <InfoOutlined fontSize="small" />
          {formik.errors[name]}
        </FormHelperText>
      )}
    </FormControl>
  )
}
export default CustomAutocompleteControl

CustomAutocompleteControl.propTypes = {
  sx: PropTypes.object,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  formik: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  labelProp: PropTypes.string,
  loading: PropTypes.bool,
  placeholder: PropTypes.string,
  customRenderOption: PropTypes.func,
}
